__turbopack_context__.v({
  "divider": "PlasmicNewsDivider-module__baORsa__divider",
});
